import Button from "@/components/Button"
import { Modals, useModals } from "@/hooks/useModals"
import ActionsDropdown from "./ActionsDropdown"
import { Event } from "@/types/serializers"

const ActionBar = ({ event }: { event: Event }) => {
  const { openModal } = useModals()

  return (
    <div className="flex items-center gap-x-1.5">
      <ActionsDropdown event={event} />
      <Button
        size="sm"
        onClick={() => openModal(Modals.EditEvent)}
        style="secondary"
      >
        Edit
      </Button>
      <Button size="sm" onClick={() => openModal(Modals.Share)}>
        Share
      </Button>
    </div>
  )
}

export default ActionBar
